
function transformPet(input, hospitalId) {
  return {
    petCode: input.id,
    name: input.name,
    type: input.type || "",
    breed: input.breed || "",
    typeId: input.type_id || "",
    breedId: input.breed_id || "",
    eyeColor: input.eye_color || "",
    furColor: input.fur_color || "",
    gender: input.gender,
    sterilizationDate: new Date(input.sterilization_date) || null,
    birthdate: new Date(input.birthdate) || null,
    image: input.image || "",
    appearanceDetail: input.appearance_detail || "",
    microchipNumber: input.microchip_number || "",
    otherReferenceNumbers: Array.isArray(input.other_reference_number)
      ? input.other_reference_number.join(",")
      : input.other_reference_number,
    bloodGroup: input.blood_group,
    drugAllergies: Array.isArray(input.drug_allergies)
      ? input.drug_allergies.join(",")
      : input.drug_allergies,
    foodAllergies: Array.isArray(input.food_allergies)
      ? input.food_allergies.join(",")
      : input.food_allergies,
    diseases: Array.isArray(input.diseases)
      ? input.diseases.join(",")
      : input.diseases,
    fatherName: input.father_name || "",
    fatherMicrochipNumber: input.father_microchip_number || "",
    motherName: input.mother_name || "",
    motherMicrochipNumber: input.mother_microchip_number || "",
    qrSecret: input.qr_secret || "",
    certificates: Array.isArray(input.certificates)
      ? input.certificates.join(",")
      : input.certificates || "",
    photos: Array.isArray(input.photos)
      ? input.photos.join(",")
      : input.photos || "",
    ownerId: input.owners && input.owners.length > 0 ? input.owners[0].id : null,
    ownerName: input.owners && input.owners.length > 0 ? `${input.owners[0].first_name} ${input.owners[0].last_name}` : "",
    ownerIdCard: input.owners && input.owners.length > 0 ? input.owners[0].idCard : "",
    hospitalId: hospitalId,
  };
}

module.exports = { transformPet };
